import { getSystemState } from "@/features/system-states/system-state";
import { SystemStatePage } from "@/features/system-states/system-state-page";
import SysMaintenance from "@/features/system-states/sys-maintenance";

export default function MaintenancePage() {
  return (
    <SystemStatePage meta={getSystemState("SYS-05")}>
      <SysMaintenance />
    </SystemStatePage>
  );
}
